import React, { useContext } from "react";
import InputControl from "../../Common/FormInputs/InputControl";
import { useForm } from "react-hook-form";
import { Card, CardBody, Col, Form, Row } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import ProjectContext from "../../../Context/ProjectContext";
import { useNavigate } from "react-router-dom";
import { ProjectPrioritySelect, ProjectTypeSelect } from "../../../Data/Project";

const MainForm = () => {
  const { addNewProject } = useContext(ProjectContext);
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const history = useNavigate();
  const formSubmitHandler = (data) => {
    addNewProject(data);
    history(`${process.env.PUBLIC_URL}/project/project-list`);
  };
  return (
    <Row className="project-cards">
      <Col sm="12">
        <Card>
          <CardBody>
            <Form id="addProject" onSubmit={handleSubmit(formSubmitHandler)} className="theme-form">
              <Row>
                <Col sm="12">
                  <InputControl controlInput="input" className="form-control" type="text" errors={errors} placeholder="Project title *" register={{ ...register("project_title", { required: "is Required." }) }} />
                </Col>
                <Col sm="12">
                  <InputControl controlInput="input" className="form-control" type="text" errors={errors} placeholder="Client Name Or Company Name *" register={{ ...register("client_name", { required: "is Required." }) }} />
                </Col>
                <Col sm="4">
                  <InputControl controlInput="input" className="form-control" type="number" errors={errors} placeholder="Enter project Rate *" register={{ ...register("project_rate", { required: "is Required." }) }} />
                </Col>
                <Col sm="4">
                  <InputControl control={control} controlInput="select" className="form-select" options={ProjectTypeSelect} errors={errors} register={{ ...register("project_type", { required: "is Required." }) }} />
                </Col>
                <Col sm="4">
                  <InputControl control={control} controlInput="select" className="form-select" options={ProjectPrioritySelect} errors={errors} register={{ ...register("priority", { required: "is Required." }) }} />
                </Col>
                <Col sm="4">
                  <InputControl control={control} controlInput="select" className="form-select" options={ProjectPrioritySelect} errors={errors} register={{ ...register("project_size", { required: "is Required." }) }} />
                </Col>
                <Col sm="4">
                  <InputControl control={control} controlInput="datepicker" className="form-control" errors={errors} register={{ ...register("starting_date", { required: "is Required." }) }} />
                </Col>
                <Col sm="4">
                  <InputControl control={control} controlInput="datepicker" className="form-control" errors={errors} register={{ ...register("ending_date", { required: "is Required." }) }} />
                </Col>
                <Col sm="12">
                  <InputControl controlInput="textarea" rows={3} placeholder="Enter Project Description" className="form-control" errors={errors} register={{ ...register("Enter some Details", { required: "is Required." }) }} />
                </Col>
                <Col sm="12">
                  <InputControl maxFiles={1} multiple={false} controlInput="dropzone" control={control} className="form-control" errors={errors} register={{ ...register("upload_project_file", { required: "is Required." }) }} />
                </Col>
                <Col className="col">
                  <div className="text-end">
                    <Btn form="addProject" type="submit" color="success" className="btn me-3">
                      Add
                    </Btn>
                    <Btn color="danger" form="addProject" type="reset" className="btn btn-danger">
                      Cancel
                    </Btn>
                  </div>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default MainForm;
